import {PanelWrapperFormlyComponent} from "../formly";

export const wrappers =  [
  { name: 'panel-div', component: PanelWrapperFormlyComponent },
]
